import update from 'react-addons-update'

import { questions } from '../constants/questions'
import { QUESTION_SET_RESULT, GET_INTRO_QUESTION_STATE, RESET_USER, SET_INTRO_QUESTION_STATE } from '../actions'

const INITIAL_STATE = {
    questions,
    status: null,
}

function IntroQuestionsReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_INTRO_QUESTION_STATE:
        case SET_INTRO_QUESTION_STATE:
            return {
                ...state,
                status: action.payload.body || state.status,
            }
        case RESET_USER:
            return {
                ...state,
                status: null,
            }
        case QUESTION_SET_RESULT:
            return update(state, {
                questions: {
                    [action.index]: {
                        answer: { $set: action.payload },
                    },
                },
            })
        default: return state
    }
}

export default IntroQuestionsReducer



// WEBPACK FOOTER //
// ./src/reducers/introQuestions.js